import PropTypes from 'prop-types'
import ButtonCta from '@components/atoms/button-cta'
import Typography from '@material-ui/core/Typography'
import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import ModalVideo from '@components/modal-video/index'
import { RenderRichText } from '@components/renderers/index'
import useStyles from './video-spotlight.styles'

const VideoSpotlight = (props) => {
  const {
    videoSpotlight,
    variant,
    flipped,
  } = props

  const {
    headline,
    overlineText,
    description,
    ctaText,
    link,
    videoImage,
    video,
    videoEmbedId,
    heading,
    eyebrow,
    supportiveCopy,
    buttonLabel,
    buttonLink,
    secondaryCtaText,
    secondaryCtaUrl,
    media,
  } = videoSpotlight

  const _headline = headline || heading
  const _overlineText = overlineText || eyebrow
  const _ctaText = ctaText || buttonLabel
  const _link = link || buttonLink
  const videoBackground = media && media.url && media.url.includes('video')
  const _video = video || (videoBackground && media)
  const _videoImage = videoImage || (!videoBackground && media)

  const styles = useStyles({ variant, flipped })

  return (
    <Container id="kickstart-career" className={styles.root}>
      <Grid className={styles.gridContainer} container>
        <Grid item xs={12} md={6} lg={6} pl={8}>
          <Box pb={0} pr={[0, 0, 4]} pl={[0, 0, 6]}>
            <Box className={styles.textContainer}>
              <Box mb=".875rem" mt={[2, 2, 0]} color="secondary.light">
                <Typography
                  variant="overline"
                  color="primary"
                  className={styles.featuredEyebrow}
                >
                  {_overlineText}
                </Typography>
                <Typography variant="h3" variantMapping={{ h3: 'h2' }}>{_headline}</Typography>
              </Box>
              <RenderRichText {...description} />
              <p className={styles.supportiveCopy}>{supportiveCopy}</p>
            </Box>
            {_ctaText && _link && (
              <ButtonCta
                variant="contained"
                color="primary"
                href={_link}
              >{_ctaText}
              </ButtonCta>
            )}
            {secondaryCtaText && secondaryCtaUrl && (
              <ButtonCta color="primary" href={secondaryCtaUrl}>
                {secondaryCtaText}
              </ButtonCta>
            )}
          </Box>
        </Grid>
        <Grid item md={6} lg={6} className={styles.mediaContainer}>
          {(_video?.url || _videoImage?.url) && (
            <Grid item xs={12}>
              <ModalVideo
                imageAssociatedWithVideo={_videoImage}
                modalVideo={_video}
                videoEmbedId={videoEmbedId}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Container>
  )
}

VideoSpotlight.propTypes = {
  variant: PropTypes.bool,
  flipped: PropTypes.bool,
  videoSpotlight: (PropTypes.shape({
    headline: PropTypes.string,
    description: PropTypes.object,
    ctaText: PropTypes.string,
    link: PropTypes.string,
    video: PropTypes.object,
    overlineText: PropTypes.string,
    videoImage: PropTypes.object,
    videoEmbedId: PropTypes.string,
    heading: PropTypes.string,
    eyebrow: PropTypes.string,
    supportiveCopy: PropTypes.string,
    buttonLabel: PropTypes.string,
    buttonLink: PropTypes.string,
    secondaryCtaText: PropTypes.string,
    secondaryCtaUrl: PropTypes.string,
    media: PropTypes.object,
  })),
}

export default VideoSpotlight
